import React from "react";
import SalesActitivityDetail from "./SalesActitivityDetail";
class SaleActivityMasterDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <SalesActitivityDetail
          SALES_ACTIVITY_ID={this.props.data.data.SALES_ACTIVITY_ID}
          CRM_CUSCODE={this.props.data.data.CRM_CUSCODE}
        />
      </div>
    );
  }
}

export default SaleActivityMasterDetailView;
